import ChatPlatform from './ChatPlatform'
import SupportChat from '../SupportChat'

export default class Intercom extends ChatPlatform {

	get name() { return 'Intercom' }
	get initOnStartup() { return true }
	get supportedFeatures() { return SupportChat.FEAT_EVENTS | SupportChat.FEAT_PAGE_VIEWS }

	init() {
		return new Promise(resolve => {
			//if Trusted Domains is enabled, it won't work with the Cordova app
			// if (window.location.hostname == 'localhost') {
			// 	throw new Error('Intercom has a trusted list of domains, and `localhost` cannot work with that. Go to 127.0.0.1 or 0.0.0.0')
			// }

			let needsResolving = false
			if (!('Intercom' in window)) {
				//a few modifications on https://www.intercom.com/help/en/articles/170-integrate-intercom-in-a-single-page-app:
				// - reformatted so, well, we can edit it since we needed, and some vars got reinflated because who cares
				// - since we're loading as needed, removed the window.onload event that would attach the script tag
				// - added an onload event to the script itself so it can resolve the promise
				// - ignored silly "suggestions" of using an ID to attach the custom trigger, and used other ways to interact with Intercom (https://developers.intercom.com/installing-intercom/docs/intercom-javascript)
				const ic = window.Intercom
				if (typeof ic === 'function') {
					ic('reattach_activator')
					ic('update', window.intercomSettings) //TODO Not sure if this has any usage for us, and a second call will cause the Intercom widget to "re-render"
					resolve()
				} else {
					const i = function () {i.c(arguments)}
					i.q     = []
					i.c     = function (args) {i.q.push(args)}

					window.Intercom = i

					const s  = document.createElement('script')
					s.type   = 'text/javascript'
					s.async  = true
					s.src    = 'https://widget.intercom.io/widget/' + this.account.chat.key
					s.onload = () => resolve(true)
					const x  = document.getElementsByTagName('script')[0]
					x.parentNode.insertBefore(s, x)
				}
			} else {
				needsResolving = true
			}

			if (!window.IntercomBooted) {
				window.IntercomBooted = true //Intercom.booted doesn't change on shutdown, so we use our own global to track user state (also handy to avoid re-run this a bunch of times........ yep, re-renders cause that)

				//https://developers.intercom.com/installing-intercom/docs/javascript-api-attributes-objects
				//https://app.intercom.com/a/apps/xg61kyke/settings/people-data
				window.Intercom('boot', {
					app_id               : this.account.chat.key,
					hide_default_launcher: true,
					language_override    : this.locale, //chinese should be zh-CN, the rest is just "fr" - https://is.gd/zJWs0U

					//created_at isn't "needed" but it is - otherwise Intercom says "signed up" since first user chat
					created_at: this.user.created_at.getTime() / 1000,
					name      : this.user.display_name,
					email     : this.user.email,
					user_id   : this.completeUsername,
					...this.extraDetails,
				})

				//https://developers.intercom.com/installing-intercom/docs/intercom-javascript
				window.Intercom('onShow', () => SupportChat.isChatOpen = true)
				window.Intercom('onHide', () => SupportChat.isChatOpen = false)
				if (needsResolving) {
					resolve(true)
				}
			}
		})
	}

	// these used to toggle hide_default_launcher too, but on first open it seems to not work, so... gave up

	get isUp() { return 'Intercom' in window && window.IntercomBooted }
	open() { window.Intercom('show') }
	close() { window.Intercom('hide') }
	nuke() {
		window.Intercom('shutdown')
		window.IntercomBooted = false //we need to track by ourselves when we need to reset user information
	}

	/**
	 * Sends up a user event. The "update" event just refreshes the current page viewed with Intercom.
	 * @param type {'update'|string}
	 * @param payload {object}
	 */
	event(type, payload = {}) { window.Intercom('trackEvent', type, payload) }

	sendPageView() { window.Intercom('update') }

}
